import { useEffect, useState } from 'react';

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  backgroundColor: 'rgba(0,0,0,0.45)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 2000,
  padding: 16
};

const dialogStyle = {
  width: '100%',
  maxWidth: 420,
  background: 'var(--card-bg, #fff)',
  color: 'var(--text, #000)',
  borderRadius: 12,
  boxShadow: '0 22px 60px rgba(0,0,0,0.4)',
  padding: 24,
  boxSizing: 'border-box'
};

const labelStyle = { display: 'block', fontSize: 13, marginBottom: 4, color: 'var(--text)' };
const inputStyle = {
  width: '100%',
  padding: '10px 12px',
  borderRadius: 6,
  border: '1px solid var(--border, #ccc)',
  background: 'var(--input-bg, #fff)',
  color: 'inherit',
  boxSizing: 'border-box'
};

export default function UserSettingsModal({
  open,
  onClose,
  onSave,
  initialTimeout,
  saving,
  error: remoteError
}) {
  const [timeoutMinutes, setTimeoutMinutes] = useState(initialTimeout || 30);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [localError, setLocalError] = useState('');

  useEffect(() => {
    if (open) {
      setTimeoutMinutes(initialTimeout || 30);
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setLocalError('');
    }
  }, [open, initialTimeout]);

  if (!open) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    setLocalError('');
    const parsedTimeout = Number(timeoutMinutes);
    if (!Number.isFinite(parsedTimeout) || parsedTimeout <= 0) {
      setLocalError('Timeout must be a positive number of minutes.');
      return;
    }
    if (newPassword && newPassword.length < 6) {
      setLocalError('New password must be at least 6 characters.');
      return;
    }
    if (newPassword && newPassword !== confirmPassword) {
      setLocalError('Password confirmation does not match.');
      return;
    }
    onSave({
      timeoutMinutes: parsedTimeout,
      currentPassword: currentPassword || '',
      newPassword: newPassword || ''
    });
  };

  return (
    <div style={overlayStyle} role="dialog" aria-modal="true" aria-label="User settings">
      <div style={dialogStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0 }}>User Settings</h3>
          <button
            className="btn-ghost"
            onClick={onClose}
            disabled={saving}
          >
            Close
          </button>
        </div>
        <p style={{ marginTop: 8, marginBottom: 16, color: 'var(--text-soft)' }}>
          Update your session timeout or change your password.
        </p>
        {(localError || remoteError) && (
          <div style={{ background: '#fdecea', color: '#b71c1c', padding: 10, borderRadius: 6, marginBottom: 12 }}>
            {localError || remoteError}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>Session Timeout (minutes)</label>
            <input
              type="number"
              min="1"
              style={inputStyle}
              value={timeoutMinutes}
              onChange={(e) => setTimeoutMinutes(e.target.value)}
            />
          </div>
          <div style={{ marginBottom: 10 }}>
            <label style={labelStyle}>Current Password (required to change password)</label>
            <input
              type="password"
              style={inputStyle}
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
            />
          </div>
          <div style={{ marginBottom: 10 }}>
            <label style={labelStyle}>New Password</label>
            <input
              type="password"
              style={inputStyle}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={labelStyle}>Confirm New Password</label>
            <input
              type="password"
              style={inputStyle}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <button type="submit" className="btn" disabled={saving}>
              {saving ? 'Saving…' : 'Save Changes'}
            </button>
            <button type="button" className="btn-ghost" onClick={onClose} disabled={saving}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
